import { Injectable } from '@angular/core';
import { MessageService, ToastMessageOptions } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class AppMessageService {
  private static instance: MessageService;

  static setInstance(messageService: MessageService) {
    AppMessageService.instance = messageService;
  }

  static getInstance(): MessageService {
    if (!AppMessageService.instance) {
      console.warn('MessageService instance not yet available');
    }
    return AppMessageService.instance;
  }

  static showMessage(message: ToastMessageOptions) {
    const instance = AppMessageService.getInstance();
    if (instance) {
      instance.add(message);
    }
  }
}
